<template>
  <ExistingItems :items="items" title="Υφιστάμενες Ομάδες Φίλτρων">
    <template v-slot:item="props">
      <router-link
        :to="{
          name: 'products.filterGroups.edit',
          params: { uuid: props.item.uuid },
        }"
      >
        {{ props.item.title }}
      </router-link>
    </template>
  </ExistingItems>
</template>

<script>
import ExistingItems from '@/views/components/ExistingItems';

export default {
  components: {
    ExistingItems,
  },
  props: {
    items: Array,
  },
};
</script>
